import { render } from "./AddTopicModal.vue?vue&type=template&id=80131076&scoped=true"
import script from "./AddTopicModal.vue?vue&type=script&lang=js"
export * from "./AddTopicModal.vue?vue&type=script&lang=js"

import "./AddTopicModal.vue?vue&type=style&index=0&id=80131076&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\versatech_vex\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80131076"]])

export default __exports__